module.exports = __webpack_public_path__ + "img/formula-w1.dc716c5b.png";